import { TableData } from '../../models/tableData/types';

export const initialTableData: TableData = {
    curPage: 1,
    pageSize: 10,
    searchString: '',
    sortDirection: 'asc',
    sortExpression: null,
};
